function SeCalendarModal() {
    document.body.classList.add('no-overflow');

    // Create the modal
    this.modal = document.createElement('div');
    this.modal.classList.add('calendar-modal');
    this.modal.classList.add('jsCloseModal');
    gsap.set(this.modal, { opacity: 0 });

    const modalInnerWrapper = document.createElement('div');
    modalInnerWrapper.classList.add('calendar-modal__inner-wrapper');
    this.modal.appendChild(modalInnerWrapper);

    const modalInner = document.createElement('div');
    modalInner.classList.add('calendar-modal__inner');
    modalInner.classList.add('jsCloseModal');
    modalInnerWrapper.appendChild(modalInner);

    this.loader = document.createElement('div');
    this.loader.classList.add('calendar-modal__loader');
    this.modal.appendChild(this.loader);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.classList.add('calendar-modal__close-btn');
    closeBtn.classList.add('jsCloseModal');
    closeBtn.innerHTML = 'Sluiten';
    this.modal.appendChild(closeBtn);

    const calWrapper = document.createElement('div');
    calWrapper.classList.add('calendar-modal__calendar');
    calWrapper.classList.add('jsCalendar');
    modalInner.appendChild(calWrapper);

    // Show the modal
    document.body.appendChild(this.modal);
    gsap.to(this.modal, 0.5, { opacity: 1, ease: 'power2.inOut' });

    // Add click listeners
    this.modal.addEventListener('click', e => {
        if (e.target.classList.contains('jsCloseModal')) {
            this.close();
        }
    });

    // On pressing escape, close the modal
    this.keyUpEventFunction = this.keyUp.bind(this);
    window.addEventListener('keyup', this.keyUpEventFunction);

    // Load the events
    const xmlhttp = new XMLHttpRequest();
    const params = new FormData();
    const self = this;

    params.append('action', 'se_get_events');

    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === XMLHttpRequest.DONE) {
            if (xmlhttp.status === 200) {
                setTimeout(_ => {
                    gsap.timeline()
                        .to(self.loader, 0.5, { opacity: 0, ease: 'power2.inOut' })
                        .set(self.loader, { display: 'none' })
                    ;
    
                    const response = JSON.parse(xmlhttp.responseText);
                    const calendarEl = self.modal.querySelector('.jsCalendar');
                    self.calendar = new FullCalendar.Calendar(calendarEl, {
                        initialView: self.getCalendarView(),
                        firstDay: 1,
                        locale: 'nl',
                        eventTimeFormat: { hour: '2-digit', minute: '2-digit', meridiem: false },
                        events: response,
                        height: self.getCalendarHeight()
                    });

                    window.addEventListener('resize', _ => self.setCalendarView());
                    window.addEventListener('resize', _ => self.setCalendarheight());
    
                    self.calendar.render();
                }, 1000);
            }
            else {
                alert('Oeps.. Er ging iets fout. Herlaad de pagina en probeer het nogmaals.');
                return false;
            }
        }
    };

    xmlhttp.open('POST', se_ajax.ajaxurl, true);
    xmlhttp.send(params);
}

SeCalendarModal.prototype.getCalendarView = function () {
    return window.innerWidth >= 1100 ? 'dayGridWeek' : 'listWeek';
};

SeCalendarModal.prototype.setCalendarView = function() {
    this.calendar.changeView(this.getCalendarView());
};

SeCalendarModal.prototype.getCalendarHeight = function() {
    return window.innerWidth >= 1100 && window.innerHeight >= 850 ? 650 : window.innerHeight - 130;
};

SeCalendarModal.prototype.setCalendarheight = function () {
    this.calendar.setOption('height', this.getCalendarHeight());
};

SeCalendarModal.prototype.keyUp = function(e) {
    if (e.key.toLowerCase() === 'escape') this.close();
};

SeCalendarModal.prototype.close = function() {
    if (this.keyUpEventFunction) {
        window.removeEventListener('keyup', this.keyUpEventFunction);
        this.keyUpEventFunction = null;
    }

    gsap.timeline()
        .to(this.modal, 0.5, { opacity: 0, ease: 'power2.inOut' })
        .add(_ => {
            this.modal.parentElement.removeChild(this.modal);
            document.body.classList.remove('no-overflow');
            this.calendar.destroy();
        })
    ;
};